/* eslint-disable import/no-named-as-default-member */
import React from 'react'
import { connect } from 'react-redux'

import { Button, Loader, Icon, Header, Label, Image, Message, Card, Grid, Form, Ref } from 'semantic-ui-react'
import _ from 'lodash'

import ItemModel from '../../../models/item'
import HasuraSearchItemActions from '../../../reducers/hasuraSearchItemReducer'

import Placeholder from './storePlaceholder'
import ItemForm from './itemSearch/form'
import SearchItemImageCropUploader from '../../../lib/SearchImageCropperUploader'

const initItemData = {
  name: '',
  current_price: 0,
  description: '',
  tag: '',
  code: '',
  status: 'publish',
  images: { image: null, thumb: null },
  skip_automate_update: true,
}

class MerchantItemsTab extends React.Component {
  state = {
    arrangeOptions: [],
    itemData: null,
    modalVisible: false,
    action: null,
    uploadDataCount: 0,
    uploadVisible: false,
    showImage: localStorage.getItem('show-items-image') || 'show',
    noChangeToItem: false,
    noItemFound: false,
  }

  searchTextRef = React.createRef()

  static getDerivedStateFromProps(props) {
    const { searchText, items, searchAttempt } = props

    if (searchText === '' && searchAttempt > 0 && items && items.length < 1) {
      return { noItemFound: true }
    }
    return null
  }

  getItemTag = tag => {
    const { tags } = this.props

    return !tag || !tags[tag] ? '...' : tags[tag]
  }

  onToggleShowImage = () => {
    let { showImage } = this.state

    showImage = showImage === 'hide' ? 'show' : 'hide'

    localStorage.setItem('show-items-image', showImage)
    this.setState({ showImage })
  }

  onDragEnd = result => {
    const { arrangeItems } = this.state

    if (!result.destination) {
      return
    }

    const items = this.reorder(arrangeItems, result.source.index, result.destination.index)

    this.setState({ arrangeItems: items })
  }

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list)

    const [removed] = result.splice(startIndex, 1)

    result.splice(endIndex, 0, removed)

    return result
  }

  onUploadImageComplete = urls => {
    const { itemData } = this.state
    const nextItemData = { ...itemData, images: urls }

    this.setState({ itemData: nextItemData })
  }

  onEdit = item => {
    const dataToEdit = {
      key: item.key || item.key,
      name: item.name || initItemData.name,
      current_price: item.current_price || initItemData.current_price,
      description: item.description || initItemData.description,
      tag: item.tag || initItemData.tag,
      status: item.status || initItemData.status,
      options: item.options,
      code: item.code || initItemData.code,
      images: item.images || initItemData.images,
      skip_automate_update: item.skip_automate_update || initItemData.skip_automate_update
    }

    const arrangeOptions = []
    _.forEach(item.options || {}, (option, optionKey) => {
      if (!option) return
      const order = arrangeOptions[option.order] ? option.order + 100 : option.order
      arrangeOptions[order] = optionKey
    })

    this.setState({
      modalVisible: true,
      itemData: dataToEdit,
      action: 'edit',
      arrangeOptions: arrangeOptions.filter(Boolean),
    })
  }

  onAddClick = () => {
    this.setState({ modalVisible: true, itemData: {...initItemData, key: ItemModel.generateKey()}, action: 'new' })
  }

  onUpload = () => {
    this.setState({ uploadVisible: true })
  }

  onClose = () => {
    this.setState({ modalVisible: false, itemData: null, action: null, arrangeOptions: [] })
  }

  onUploadClose = () => {
    this.setState({ uploadVisible: false })
  }

  onFieldChange = (field, value) => {
    let { itemData } = this.state

    itemData = {
      ...itemData,
      [field]: value,
    }

    this.setState({ itemData })
  }

  onRemoveOption = key => {
    const { arrangeOptions: prevArrangeOptions } = this.state
    const arrangeOptions = prevArrangeOptions.filter(optionKey => optionKey !== key)
    this.setState({ arrangeOptions })
  }

  onOptionOrderChange = (currentIndex, direction) => {
    const { arrangeOptions: prevArrangeOptions } = this.state
    const arrangeOptions = Array.from(prevArrangeOptions)
    const lastOptionIndex = prevArrangeOptions.length - 1

    if (direction === 'up' && currentIndex === 0) return
    if (direction === 'down' && currentIndex === lastOptionIndex) return

    const destinationIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1
    const targetKey = arrangeOptions[currentIndex]
    const destinationKey = arrangeOptions[destinationIndex]
    arrangeOptions[currentIndex] = destinationKey
    arrangeOptions[destinationIndex] = targetKey
    this.setState({ arrangeOptions })
  }

  onDelete = async item => {
    const { addItem } = this.props
    const { key } = item
    addItem({ isDelete: true, ...item }, key)
  }

  onSaveChange = () => {
    const { action, itemData, arrangeOptions } = this.state
    const { addItem, items=[] } = this.props

    const { key: itemId} = itemData

    const arrangedOptions = _.reduce(
      itemData.options,
      (accum, option, optionKey) => {
        const newAccum = accum
        const orderNumber = arrangeOptions.indexOf(optionKey)
        const optionObject = orderNumber >= 0 ? { order: orderNumber + 1 } : null

        newAccum[optionKey] = optionObject
        return newAccum
      },
      {}
    )
    const alterItem = { ...itemData, options: arrangedOptions }

    if (action === 'edit') {
      const originalItem = _.pick(items.find(i => i.key === alterItem.key), Object.keys(itemData))
      if (_.isEqual(alterItem, originalItem)) {
        this.setState({ noChangeToItem: true }, () => {
          setTimeout(() => {
            this.setState({ noChangeToItem: false })
          }, 2000)
        })
        return this.onClose()
      }
    }
    addItem(alterItem, itemId)

    return this.onClose()
  }

  renderLoading = () => <Placeholder />

  decorateItem = item => {
    const { itemOptions } = this.props
    const { tag, options = {} } = item

    return {
      ...item,
      displayTag: this.getItemTag(tag),
      displayOptions: _.map(options, (o, key) => o && itemOptions[key].name),
    }
  }

  renderItem = (item, index) => {
    const { showImage } = this.state

    const decoratedItem = this.decorateItem(item)
    return (
      <ItemCard key={index} item={decoratedItem} showImage={showImage}>
        <div className="ui two buttons">
          <Button basic color="green" onClick={() => this.onEdit(item)}>
            Edit
          </Button>
          <Button basic color="red" onClick={() => this.onDelete(item)}>
            Delete
          </Button>
        </div>
      </ItemCard>
    )
  }

  handleFormSubmit = e => {
    e.preventDefault()
    const { searchItems, storeId } = this.props
    const searchText = this.searchTextRef.getElementsByTagName('input')[0].value

    searchItems(storeId, searchText)
  }

  handleUpdateAlterItems = alterItemsLength => {
    const { updateAlterItems, storeId } = this.props
    updateAlterItems(storeId)

    this.setState({ uploadDataCount: alterItemsLength }, () => {
      setTimeout(() => {
        this.setState({ uploadDataCount: 0 })
      }, 2000)
    })
  }

  renderAlterItemHeader = () => {
    const { alterItems, itemSyncLoading, loading } = this.props
    const isDisable = loading || itemSyncLoading || alterItems.length <= 0

    return (
      <Grid columns={2}>
        <Grid.Row>
          <Grid.Column>
            <Header size="large">Alter Items</Header>
          </Grid.Column>
          <Grid.Column>
            <Button
              color="green"
              onClick={() => this.handleUpdateAlterItems(alterItems.length)}
              disabled={isDisable}
              icon
              floated="right"
            >
              Submit <Icon name="save" />
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }

  renderAlterItems = () => {
    const { showImage } = this.state
    const { alterItems, removeItem } = this.props

    return (
      <React.Fragment>
        <h3>Alter Items: {alterItems ? alterItems.length : 0}</h3>
        <Card.Group stackable>
          {alterItems.map((item, index) => {
            const { key } = item
            const decoratedItem = this.decorateItem(item)

            return (
              // eslint-disable-next-line react/no-array-index-key
              <ItemCard key={index} item={decoratedItem} showImage={showImage}>
                <div className="ui two buttons">
                  <Button basic color="green" onClick={() => this.onEdit(item)}>
                    Edit
                  </Button>
                  <Button basic color="red" onClick={() => removeItem(key)}>
                    Cancel
                  </Button>
                </div>
              </ItemCard>
            )
          })}
        </Card.Group>
      </React.Fragment>
    )
  }

  renderSearchBar = () => {
    const { itemSyncLoading } = this.props
    return (
      <Grid columns={2}>
        <Grid.Row>
          <Grid.Column>
            <Header size="large">Items</Header>
          </Grid.Column>
          <Grid.Column>
            <Form onSubmit={this.handleFormSubmit} style={{ display: 'flex' }}>
              <Ref
                innerRef={node => {
                  this.searchTextRef = node
                }}
              >
                <Form.Input
                  // icon="search"
                  placeholder="Name or Code ..."
                  style={{ width: '100%' }}
                  // value=""
                  // onChange={e => {
                  //   console.log(this.searchTextRef)
                  //   this.setState({ searchText: e.target.value })
                  // }}
                />
              </Ref>
              <Form.Button
                icon
                color="black"
                onClick={this.handleFormSubmit}
                floated="right"
                disabled={itemSyncLoading}
              >
                <Icon name="search" /> search
              </Form.Button>
            </Form>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }

  renderSearchItems = () => {
    const { items } = this.props
    return (
      <React.Fragment>
        <h3>Found Items: {items ? items.length : 0}/50</h3>
        <Card.Group stackable>
          {items && items.map((item, index) => this.renderItem(item, index))}
        </Card.Group>
      </React.Fragment>
    )
  }

  renderForm = () => {
    const { storeData, tags, adding, storeId, itemOptions } = this.props
    const { itemData, modalVisible, uploadVisible, arrangeOptions, action, showImage } = this.state
    const { key: itemKey } = itemData

    return (
      <div>
        {itemData && (
          <ItemForm
            storeData={storeData}
            showImage={showImage}
            tags={tags}
            loading={adding}
            visible={modalVisible}
            itemData={itemData}
            itemOptions={itemOptions}
            arrangeOptions={arrangeOptions}
            onClose={this.onClose}
            action={action}
            onFieldChange={this.onFieldChange}
            onOptionOrderChange={this.onOptionOrderChange}
            onRemoveOption={this.onRemoveOption}
            saveItem={this.onSaveChange}
            onUpload={this.onUpload}
          />
        )}
        {itemData && (
          <SearchItemImageCropUploader
            visible={uploadVisible}
            label="Image"
            onClose={this.onUploadClose}
            onUploadComplete={this.onUploadImageComplete}
            compressWidth={250}
            compressHeight={250}
            uploadPath={`items/${itemKey}`}
            dbPath={`items/${storeId}/${itemKey}`}
          />
        )}
      </div>
    )
  }

  render() {
    const { loading } = this.props
    const { showImage, noChangeToItem, noItemFound, modalVisible, uploadDataCount } = this.state
    const hasItem = !noItemFound
    const hasChangeItems = !noChangeToItem

    return (
      <div>
        <Message color="green" hidden={uploadDataCount <= 0} content={`${uploadDataCount} items uploading`} />
        <Message color="orange" hidden={hasChangeItems} content="No Update to Item" />
        <Message
          color="red"
          hidden={hasItem}
          content="No Items Found"
          onDismiss={() => {
            this.setState({ noItemFound: false })
          }}
        />
        <Button icon onClick={this.onToggleShowImage} style={{ marginBottom: 20 }}>
          <Icon name={showImage === 'hide' ? 'circle outline' : 'check circle outline'} /> Show Image
        </Button>
        <Button icon color="black" onClick={this.onAddClick} floated="right">
          <Icon name="add" /> Add New Item
        </Button>
        {modalVisible && this.renderForm()}
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column>{this.renderSearchBar()}</Grid.Column>
            <Grid.Column>{this.renderAlterItemHeader()}</Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              {loading ? <Loader active inline="centered" /> : this.renderSearchItems()}
            </Grid.Column>
            <Grid.Column>
              {loading ? <Loader active inline="centered" /> : this.renderAlterItems()}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    )
  }
}

const ItemCard = ({ item, children, showImage }) => {
  const {
    isDelete,
    key,
    name,
    images: { thumb = '' },
    description,
    code,
    displayTag,
    displayOptions,
    status,
    current_price: currentPrice,
  } = item
  const itemStatus = _.isNull(status) ? 'publish' : status
  const cardColor = itemStatus === 'publish' ? 'green' : 'red'

  return (
    <Card key={key} color={cardColor}>
      {isDelete && (
        <Label attached="top right" color="red">
          DELETE
        </Label>
      )}
      <Card.Content>
        {showImage === 'show' && thumb ? (
          <Image floated="left" size="tiny" src={thumb} />
        ) : (
          <Button
            floated="left"
            size="tiny"
            style={{
              height: 80,
              width: 80,
            }}
          >
            No Image
          </Button>
        )}
        <Card.Header>{name}</Card.Header>
        <Card.Meta style={{ minHeight: 10 }}>{description}</Card.Meta>
        <Card.Description>
          <i>{code}</i>
          <Grid columns={3} divided>
            <Grid.Row>
              <Grid.Column>
                <Label color="red">$ {currentPrice}</Label>
              </Grid.Column>
              <Grid.Column>
                <Label size="medium">{itemStatus}</Label>
              </Grid.Column>
              <Grid.Column>
                <Label size="medium">{displayTag}</Label>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Grid columns={1} divided>
            <Grid.Row>
              <Grid.Column>
                {_.map(displayOptions.filter(Boolean), (option, index) => (
                  <Label key={index} size="medium" color="blue">
                    {option}
                  </Label>
                ))}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Description>
      </Card.Content>
      <Card.Content extra>{children}</Card.Content>
    </Card>
  )
}

const mapStateToProps = ({ hasuraSearchItems, itemOptions, itemSync }, { storeId }) => ({
  alterItems: hasuraSearchItems.alterItems,
  itemSyncLoading: itemSync.loading,
  loading: hasuraSearchItems.loading,
  loaded: hasuraSearchItems.loaded,
  searchAttempt: hasuraSearchItems.searchAttempt,
  itemOptions: itemOptions.data[storeId] || {},
  items: hasuraSearchItems.items,
  searchText: hasuraSearchItems.searchText,
})

const mapDispatch = {
  searchItems: HasuraSearchItemActions.searchItems,
  searchItemsSuccess: HasuraSearchItemActions.searchItemsSuccess,
  updateAlterItems: HasuraSearchItemActions.updateAlterItems,
  addItem: HasuraSearchItemActions.addItem,
  removeItem: HasuraSearchItemActions.removeItem,
}

export default connect(
  mapStateToProps,
  mapDispatch
)(MerchantItemsTab)



// WEBPACK FOOTER //
// ./src/components/restaurants/views/itemSearch.js